"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getJellyHubCanisterId = exports.DEFAULT_HOST = void 0;
// TODO: Set production canister id once it's deployed
const PRODUCTION_HUB_CANISTER_ID = '';
exports.DEFAULT_HOST = 'https://ic0.app';
const getJellyHubCanisterId = () => {
    // Create react build source code overrides NODE_ENV
    // https://github.com/facebook/create-react-app/blob/3880ba6cfd98d9f2843217fd9061e385274b452f/packages/react-scripts/scripts/build.js#L13
    if (process.env.NODE_ENV === 'production' && !process.env.REACT_APP_NODE_ENV)
        return PRODUCTION_HUB_CANISTER_ID;
    // React and Vue only accept prefixed env variables without overriding webpack
    return process.env.HUB_ID || process.env.REACT_APP_HUB_ID || process.env.VUE_APP_HUB_ID || '';
};
exports.getJellyHubCanisterId = getJellyHubCanisterId;
